/* SEERAT v5.4.0 — Facticied */
/* Seerat product tabs. Every panel is in the page already, so the copy is there
   with no JS; this adds the switching and the keyboard behaviour a tablist needs. */
(function () {
  'use strict';

  class SeeratPtabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.seerat-pt__tab'));
      this.panels = Array.from(this.querySelectorAll('.seerat-pt__panel'));
      if (this.tabs.length === 0) return;

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => this.onKey(e, i));
      });

      this.select(0);
    }

    onKey(event, index) {
      var keys = { ArrowRight: 1, ArrowLeft: -1, Home: 'first', End: 'last' };
      var move = keys[event.key];
      if (move === undefined) return;
      event.preventDefault();

      var next;
      if (move === 'first') next = 0;
      else if (move === 'last') next = this.tabs.length - 1;
      else next = (index + move + this.tabs.length) % this.tabs.length;

      this.select(next);
      this.tabs[next].focus();
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
    }
  }

  if (!customElements.get('seerat-ptabs')) {
    customElements.define('seerat-ptabs', SeeratPtabs);
  }
})();
